require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./betreuungseinrichtungen-guessing-moschendorf.json") })
        }
      }, "path---betreuungseinrichtungen-guessing-moschendorf");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---betreuungseinrichtungen-guessing-moschendorf!./.cache/json/betreuungseinrichtungen-guessing-moschendorf.json
// module id = 895
// module chunks = 231608221292675